module.exports = __webpack_public_path__ + "img/1440.f8df5006.svg";